import React from "react"
import _ from "lodash"
import { localizeNum } from "data/lib/numbers"

const InputTypeDisplay = (props: {rowData: {}, field: string}) => {
  const data = _.get(props.rowData, props.field)
  let display = ''

  if (data?.state === 'basic' || _.get(props, 'rowData.inputtype') === 'basic'){
    display = `New: ${props.rowData['mosnew'] ? localizeNum(props.rowData['mosnew'], 2) : 'N/A'} - Renew: ${props.rowData['mosrenew'] ? localizeNum(props.rowData['mosrenew'], 2) : 'N/A'}`
  } else if (data?.state === 'detailed'){
    display = "Detailed"
  } else if (data?.state === 'withinLease') {
    display = "Within Lease"
  } else {
    display = "-"
  }

  return (
    <span>{display}</span>
  )
}

export default InputTypeDisplay
